import React from 'react';
import ReactDOM from 'react-dom/client';
import JSONFieldExplorer from './jsonfieldexplorer.js';
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <JSONFieldExplorer />
  </React.StrictMode>
);
